function Hello() {
    return <h1>Adrian Lewandowski 21257</h1>;
}

export default Hello;